// Preserve the existing Team intake entry-point roles. Server-side boutique and
// role checks remain authoritative in the unchanged employee intake.
export const canAddEmployeeRecord = user => ["owner", "coo", "recruiter", "onboarding_admin", "boutique_manager"].includes(user?.role);

export const canViewEmployeeRecords = user => canAddEmployeeRecord(user) || user?.employee_record_access?.can_manage === true;
